/**
 * BOT PREVENTION for forms
 */
(function ($, window) {

    $(function() {
        $('form:not(.processedtoken)').each(formhandle);
        $( document ).ajaxComplete(formhandle);
    });

    function formhandle() {
        var formToken = Contenda.formtok;

        $('form:not(.processedtoken)').each(function(idx,form) {
            $(form).append('<input type="hidden" name="formtok" value="' + formToken + '"/>');
            // Honeypot: moved off-screen rather than display:none, so bots that skip hidden fields still fill it in.
            // BotPreventionFilter rejects the POST if it is not empty.
            $(form).append(
                '<div aria-hidden="true" style="position:absolute;left:-9999px;top:auto;width:1px;height:1px;overflow:hidden;">' +
                    '<label>Lad dette felt være tomt <input type="text" name="kom_hp" value="" tabindex="-1" autocomplete="off"/></label>' +
                '</div>'
            );
            $(form).addClass('processedtoken');
        });
    }

})(jQuery, window);